import { TOS_VERSION } from "@apsu/shared";
import { Navigate, Outlet, useLocation, useParams } from "react-router";
import { useAuth } from "../context/auth";

export function RequireTos() {
	const { user } = useAuth();
	const { workspaceSlug } = useParams<{ workspaceSlug: string }>();
	const location = useLocation();

	if (user?.tosVersionAccepted !== TOS_VERSION) {
		const returnTo = encodeURIComponent(location.pathname + location.search);
		return (
			<Navigate
				to={`/${workspaceSlug}/accept-terms?returnTo=${returnTo}`}
				replace
			/>
		);
	}

	return <Outlet />;
}
